import reddot from '../reddot/reddot.vue.component';
import EventBus from '../../scripts/lib/EventBus.js';

const templateElement = document.getElementById('vsp-button-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    syan: {
      type: Number,
      required: true,
    },
    colorId: {
      type: String,
      required: false,
    },
  },

  components: {
    reddot,
  },

  setup(props) {
    function getVspPayload() {
      return {
        syan: props.syan,
        ...(props.colorId ? { farbId: props.colorId } : {}),
        listName: 'pds_icon',
      };
    }

    function triggerVsp() {
      const vspPayload = getVspPayload();
      document.dispatchEvent(new CustomEvent('suchen:vsp:alternativeprodukte', { detail: vspPayload }));
      console.info('Visuell ähnliche Produkte werden angezeigt:', vspPayload);
      this.$el.setAttribute('data-test-ents-vsp-button-payload-emitted', JSON.stringify(vspPayload));
      EventBus.emit('reddot:read', 'vsp');
    }

    return {
      triggerVsp,
    };
  },
};
